module.exports = "/assets/31febc3404e225ed64bcfb90a129da41.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MW.png
// module id = 2753
// module chunks = 0